import { Navigation } from '@cmg/common';
import React from 'react';
import { connect } from 'react-redux';
import { useMatch } from 'react-router-dom';

import routeFactory from '../../common/util/routeFactory';
import { selectAccount } from './shared/ducks';

const mapStateToProps = state => ({
  account: selectAccount(state),
});

type Props = ReturnType<typeof mapStateToProps>;

export const AccountBreadcrumbComponent: React.FC<Props> = ({ account }) =>
  !!account && account.subdomain !== 'system' ? (
    <Navigation.Breadcrumb>
      <Navigation.Link
        to={routeFactory.accountDetail.getUrlPath({
          accountSubdomain: account.subdomain,
        })}
      >
        {account.name}
      </Navigation.Link>
    </Navigation.Breadcrumb>
  ) : null;

const ConnectedAccountBreadcrumb = connect(mapStateToProps)(AccountBreadcrumbComponent);

/**
 * Displays an account name as a route link to account detail.
 * For use in the app Navbar when sys admin is looking at a particular account.
 */
const AccountBreadcrumb = () => {
  const match = useMatch(`${routeFactory.accountDetail.routePath}/*`);

  return match ? <ConnectedAccountBreadcrumb /> : null;
};

export default AccountBreadcrumb;
